var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef } from '@angular/core';
import { IntegratorService } from 'app/services/integrator.service';
import { UserService } from 'app/services/user.service';
import { CommonTableService } from 'app/services/common-table.service';
import { ToastrService } from 'ngx-toastr';
import { PaneControlService } from 'app/services/pane-control.service';
var ConfigIntegratorsComponent = /** @class */ (function () {
    function ConfigIntegratorsComponent(toastr, integratorService, tableService, paneService, userService) {
        this.toastr = toastr;
        this.integratorService = integratorService;
        this.tableService = tableService;
        this.paneService = paneService;
        this.userService = userService;
        this.integrators = [];
        this.selectedIntegrator = null;
        // public currentIntegrators: Integrator[] = [];
        this.columns = [];
    }
    ConfigIntegratorsComponent.prototype.changeIntegrator = function () {
    };
    // public async addIntegrator() {
    // 	if (this.selectedIntegrator && this.userService.getUserInfo().isAdmin) {
    // 		try {
    // 			await this.integratorService.addIntegratorClient(this.selectedIntegrator.cusId, this.userService.getUserInfo().customerId, this.userService.getUserInfo().userId);
    // 			await this.setTable();
    // 			this.toastr.success('Successfull invited.');
    // 		} catch (err) {
    // 			console.log(err);
    // 		}
    // 	}
    // }
    ConfigIntegratorsComponent.prototype.inviteIntegrator = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.integratorService.addIntegratorClient(row.cusId, this.userService.getUserInfo().customerId, this.userService.getUserInfo().userId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setTable()];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully invited.');
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        this.toastr.error('Operation failed.');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfigIntegratorsComponent.prototype.uninviteIntegrator = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.integratorService.deleteIntegratorClient(row.giaId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setTable()];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully univited.');
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.toastr.error('Operation failed.');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfigIntegratorsComponent.prototype.setTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentIntegrators, integrators;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.integratorService.getIntegrators(this.userService.getUserInfo().customerId)];
                    case 1:
                        currentIntegrators = _a.sent();
                        integrators = this.integrators.map(function (i) { return i; });
                        integrators.forEach(function (i) {
                            var c = currentIntegrators.find(function (c) { return i.cusId === c.cusId; });
                            if (c) {
                                i.isSelected = true;
                                i.giaId = c.giaId;
                            }
                            else {
                                i.isSelected = false;
                                i.giaId = null;
                            }
                        });
                        // this.currentIntegrators = currentIntegrators;
                        this.integrators = integrators.sort(function (a, b) {
                            return (a.isSelected === b.isSelected) ? 0 : a.isSelected ? -1 : 1;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigIntegratorsComponent.prototype.setColumns = function () {
        var _this = this;
        var meta = [
            { name: 'Integrator', prop: 'nameShort', width: 150, headerAlign: 'L' },
            { name: 'Description', prop: 'nameLong', headerAlign: 'L' },
            { name: 'Administrator', prop: 'adminUsers', cellTempl: this.adminUsersTempl, headerAlign: 'L' },
            { name: ' ', prop: 'operations', cellTempl: this.operationsTempl, align: 'R' }
        ];
        var columns = [];
        meta.forEach(function (m) { return columns.push(_this.tableService.setNewColumn(m.prop, m.name, {
            width: m.width,
            cellTemplate: m.cellTempl,
            align: m.align,
            headerAlign: m.headerAlign
        })); });
        this.columns = columns;
    };
    ConfigIntegratorsComponent.prototype.setRowClass = function (row) {
        if (!row.isSelected) {
            return 'uninvited-integrator';
        }
    };
    ConfigIntegratorsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
                        this.paneService.currPane.next({
                            paneType: 'config',
                            submenu: 'configIntegrators'
                        });
                        this.setColumns();
                        if (!(!this.integratorService.integrators || !this.integratorService.integrators.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.integratorService.getIntegrators(null, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.integrators = this.integratorService.integrators;
                        this.setTable();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConfigIntegratorsComponent;
}());
export { ConfigIntegratorsComponent };
